import type { MaterialValue } from '@rogue/rackbuilder'
import type { PlateOptions, BarConfig } from '../../RackTypes'
import type { IRogue, Product } from '@/js/services/RogueTypes'

export function getPlateConfig(rogue: IRogue, product: Product): PlateOptions {
  const name = product.name.toLowerCase()

  let hgPlates: PlateOptions = [
    { line: 'hg', weight: '45' }, { line: 'hg', weight: '35' }, { line: 'hg', weight: '25' }, { line: 'hg', weight: '15' }, { line: 'hg', weight: '10' }]

  if (name.includes('230')) {
    // Remove the 15s from the 230lb set
    hgPlates = hgPlates.filter(p => p.weight !== '15')
  }

  return hgPlates
}

export function getBarConfig(rogue: IRogue, product: Product, plates?: Product) : BarConfig {
  const name = product.name.toLowerCase()

  let barType: BarConfig['barType'] = 'ohio'
  let endcap: string = 'ohio'

  // @todo make this work with product.attributes instead of names...

  const bronze: MaterialValue = { material: 'custom', color: '#a27e29', config: { metalness: 0.8, roughness: 0.3 } }

  // Default to Ohio Bar - Black Zinc
  let sleeves:MaterialValue = { material: 'stainless' }
  let bushing:MaterialValue = bronze

  const knurl:MaterialValue = { material: 'knurl', color: '#555555', config: { mapRepeat: 0.75, metalness: 0.8, roughness: 0.5 } }
  const shaft:MaterialValue = { material: 'mg', color: '#111111' }

  if (name.includes('bella bar 2.0 - black zinc')) {
    barType = 'bella'
    endcap = 'bella'
  } else if (name.includes('power bar - black zinc')) {
    barType = 'power'
    endcap = name.includes('45') ? 'powerbar-45' : 'powerbar-20'
  } else if (name.includes('echo bar')) {
    endcap = 'echo'
    shaft.material = 'stainless'
    knurl.color = '#d2d7dd'
  } else if (name.includes('rogue bar 2.0')) {
    endcap = 'rogue2.0'
    bushing = { material: 'powdercoat' }
  } else if (name.includes('b&r')) {
    knurl.color = '#d2d7dd'
    shaft.material = 'stainless'
    bushing = bronze
    endcap = 'br'
    barType = 'power'
  } else if (name.includes('ohio') && name.includes('oxide')) {
    sleeves = { material: 'mg' }
  }

  if (name.includes('ohio') && name.includes('cerakote')) {
    endcap = 'ohio-cerakote'
  }

  return {
    barType,
    sleeves,
    bushing,
    knurl,
    shaft,
    endcap,
    plates: plates ? getPlateConfig(rogue, plates) : undefined,
  }
}
